import type { CreateGenerationRequest } from './api';

/**
 * Генерация, которую юзер хотел запустить, но не хватило денег.
 * После оплаты запускаем сами («После оплаты генерация запустится сама»).
 * localStorage — потому что платёжка может открыться во внешнем браузере и мини-апп перезапустится.
 */
const KEY = 'trendator:pending-generation';
const TTL_MS = 30 * 60 * 1000;

export function savePending(req: CreateGenerationRequest): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ req, at: Date.now() }));
  } catch {
    /* приватный режим — просто не запустим сами */
  }
}

export function takePending(): CreateGenerationRequest | null {
  try {
    const raw = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    if (!raw) return null;
    const { req, at } = JSON.parse(raw) as { req: CreateGenerationRequest; at: number };
    return Date.now() - at < TTL_MS ? req : null;
  } catch {
    return null;
  }
}

export function clearPending(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ничего */
  }
}
